import CardCarousel from '../components/CardCarousel';
import Swiper, { Scrollbar, Navigation } from 'swiper';
Swiper.use([Scrollbar, Navigation]);

export default class CRelatedStoryCarousel extends CardCarousel {
	constructor(elm) {
		super(elm);

        this.orientation = elm.getAttribute('data-orientation');

        if (this.orientation === 'portrait') {
            this.breakpoints = {
                576: {
                    slidesPerView: 2,
                        spaceBetween: 10,
				},
                768: {
                    slidesPerView: 3,
                        spaceBetween: 14,
				},
                992: {
                    slidesPerView: 3,
                        spaceBetween: 14,
				},
                1200: {
                    slidesPerView: 4,
                        spaceBetween: 14,
				},
                1600: {
                    slidesPerView: 5,
                        spaceBetween: 14,
				}
            }
        } else {
            this.breakpoints = {
                576: {
                    slidesPerView: 2,
                        spaceBetween: 10,
				},
                768: {
                    slidesPerView: 4,
                        spaceBetween: 14,
				},
                1200: {
                    slidesPerView: 5,
                        spaceBetween: 14,
				},
                1600: {
                    slidesPerView: 5,
                    spaceBetween: 14,
				}
            }
        }

        this.init();
	}

	init() {
		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
			scrollbar: {
				el: this.scrollbar,
				draggable: true,
				hide: false,
			},
			slidesPerView: 1,
			spaceBetween: 10,
            breakpoints: this.breakpoints
		});

		this.swiper.init();
	}
}
